import { render, staticRenderFns } from "./ExpandableGoalItem.vue?vue&type=template&id=13eedbc0"
import script from "./ExpandableGoalItem.ts?vue&type=script&lang=ts&external"
export * from "./ExpandableGoalItem.ts?vue&type=script&lang=ts&external"
import style0 from "./ExpandableGoalItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports